var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _vm.device === "mobile"
        ? _c("Hamburger", {
            staticClass: "hamburger-container",
            attrs: {
              id: "hamburger-container",
              "is-active": _vm.sidebar.opened,
            },
            on: { toggleClick: _vm.toggleSideBar },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _vm.getAuthorityShowAI
                  ? _c(
                      "div",
                      { staticClass: "ai-icon", on: { click: _vm.openAIPage } },
                      [
                        _c("img", {
                          staticClass: "ai-icon-img",
                          attrs: {
                            src: require("@/assets/image/aigc/digitalVideoManage/ai-icon-head.png"),
                          },
                        }),
                        _c("span", [_vm._v("AI管家")]),
                      ]
                    )
                  : _vm._e(),
                _c("TrainVideo"),
                _vm.showTask
                  ? _c("Task", {
                      staticClass: "right-menu-item",
                      attrs: { id: "header-task" },
                    })
                  : _vm._e(),
                _c("DownloadHeader", { staticClass: "right-menu-item" }),
              ]
            : _vm._e(),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _c("AppAvatar", {
                    attrs: {
                      name: _vm.userInfo.nickName || _vm.userInfo.userName,
                      width: "35",
                      avatar: _vm.userInfo.avatar,
                      "no-name": true,
                    },
                  }),
                  _c("i", { staticClass: "el-icon-caret-bottom" }),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c(
                        "el-dropdown-item",
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class": "navbar_home",
                              "class-name": "m-r-10 w_16",
                            },
                          }),
                          _c("span", { staticClass: "dropdownItemText" }, [
                            _vm._v("首页"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.showUserInfo()
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class": "navbar_userinfo",
                          "class-name": "m-r-10 w_16",
                        },
                      }),
                      _c("span", { staticClass: "dropdownItemText" }, [
                        _vm._v("个人信息"),
                      ]),
                    ],
                    1
                  ),
                  _vm.getAuthEmployeeInfoDetail
                    ? _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.toUserDetails()
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class": "navbar_userinfo",
                              "class-name": "m-r-10 w_16",
                            },
                          }),
                          _c("span", { staticClass: "dropdownItemText" }, [
                            _vm._v("员工信息"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.updatePassword()
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class": "navbar_password",
                          "class-name": "m-r-10 w_16",
                        },
                      }),
                      _c("span", { staticClass: "dropdownItemText" }, [
                        _vm._v("修改密码"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onhandleSwitchAccount()
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class": "navbar_org",
                          "class-name": "m-r-10 w_16",
                        },
                      }),
                      _c("span", { staticClass: "dropdownItemText" }, [
                        _vm._v("切换账号"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onhandleSwitchOrg()
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class": "navbar_org",
                          "class-name": "m-r-10 w_16",
                        },
                      }),
                      _c("span", { staticClass: "dropdownItemText" }, [
                        _vm._v("切换机构"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.bindingClick()
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class": "navbar_bd",
                          "class-name": "m-r-10 w_16",
                        },
                      }),
                      _c("span", { staticClass: "dropdownItemText" }, [
                        _vm._v("解绑/绑定"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.showHokClawAuth()
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class": "navbar_userinfo",
                          "class-name": "m-r-10 w_16",
                        },
                      }),
                      _c("span", { staticClass: "dropdownItemText" }, [
                        _vm._v("Skill授权"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.showBroadcastTask()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-mobile-phone" }),
                      _c("span", { staticClass: "dropdownItemText" }, [
                        _vm._v("企微托管"),
                      ]),
                    ]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticStyle: { display: "block" } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class": "navbar_logout",
                              "class-name": "m-r-10 w_16",
                            },
                          }),
                          _c("span", { staticClass: "dropdownItemText" }, [
                            _vm._v("退出登录"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("PasswordModal", { attrs: { config: _vm.config } }),
      _c("homeUserInfo", { attrs: { config: _vm.userInfoConfig } }),
      _c("hokClawAuthDialog", { attrs: { config: _vm.hokClawAuthConfig } }),
      _c("CrmLoginInfo", { ref: "crmLoginInfo" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }